import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fury-consulterhistcarte',
  templateUrl: './consulterhistcarte.component.html',
  styleUrls: ['./consulterhistcarte.component.scss']
})
export class ConsulterhistcarteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
